<template lang="pug">
  div
    v-alert(:value="showError && !!note.error" @input="showError = false" dismissible type="error") {{note.error}}
    v-alert(:value="showSuccess && !!note.success" @input="showSuccess = false" dismissible type="success") {{note.success}}
</template>

<script>
export default {
  props: ['extra'],
  data() {
    return {
      showError: false,
      showSuccess: false
    }
  },
  computed: {
    note() {
      this.showError = true
      this.showSuccess = true
      return this.extra && JSON.parse(this.extra.content) || {}
    }
  }
}
</script>
